module.exports = __webpack_public_path__ + "static/media/Diluc.f5ae62ef.png";